<template>
    <app-layout>
        <template #header>
            <div class="relative mb-6">
                <div class="absolute mb-4 right-0">
                    <div class="col-span-2">
                        <balance :short="true" />
                    </div>
                </div>
                <div>
                    <a :href="route('values-receive.index')">
                        <h2 class=" font-bold text-xl leading-tight">
                            <i class="fas fa-hand-holding-usd"></i>
                            Valores a receber
                        </h2>
                    </a>
                </div>
            </div>
        </template>
        <div class="py-12 mt-9">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div
                    class="bg-white overflow-visible h-auto shadow-xl sm:rounded-lg px-4 py-4"
                >
                    <flash :timeout="5000" />
                    <div>
                        <h1 class="font-bold text-xl">Lista de transações</h1>
                        <div
                            class="flex justify-end mb-8 items-center space-x-6"
                        >
                            <span class="text-sm"
                                >(Saque disponível:<b>
                                    R${{ availableMoney | currency }}</b
                                >)</span
                            >
                            <span class="text-sm text-center"
                                >Saque automático</span
                            >
                            <toggle-button
                                class="text-center text-sm"
                                v-model="daily"
                                :sync="true"
                                :labels="{
                                    unchecked: 'Inativo',
                                    checked: 'Ativo'
                                }"
                                :color="{
                                    unchecked: '#E9E9E9',
                                    checked: '#03C9A1'
                                }"
                                :width="65"
                                :font-size="12"
                                content="Atenção <br> Ao ativar esta opção, você estará <br> acionando o saque automático <br>que ocorre diariamente às 2:00<br> a.m, horário de Brasilia."
                                @change="activateCash()"
                                v-tippy
                            />

                            <inertia-link
                                class=" px-2 py-1 bg-gray-800 border border-transparent rounded-sm font-semibold text-xs"
                                :href="route('request-withdrawal.withdrawal')"
                            >
                                <i
                                    class="px-1 text-white fas fa-arrow-circle-down"
                                ></i>
                                <div class="w-full text-center text-white">
                                    Receber valores
                                </div>
                            </inertia-link>
                        </div>
                    </div>

                    <inertia-table
                        tableClasses="border-t-2 mt-8 text-xs"
                        :icon="false"
                        :data="valuesReceive"
                        :params="params"
                        :filters="filters"
                        :columns="columns"
                        routeName="list-receive.listReceive"
                        parent="listReceive"
                        id="id"
                    >
                        <template slot-scope="row" slot="status">
                            <div class="flex items-center">
                                <div
                                    class="text-center align-center items-center my-auto"
                                >
                                    <div
                                        class="rounded-full hover:bg-gradient-to-br  h-8 w-8 py-2 px-2"
                                        :class="statusData(row.item.status).bg"
                                        :content="
                                            statusData(row.item.status).name
                                        "
                                        v-tippy
                                    >
                                        <em
                                            class="text-center "
                                            :class="
                                                statusData(row.item.status).icon
                                            "
                                            style="font-size: 15px;"
                                        >
                                        </em>
                                    </div>
                                </div>
                            </div>
                        </template>

                        <template slot-scope="row" slot="movement.date_brt">
                            <span
                                v-if="row.item.movement"
                                class="text-left text-gray-700"
                                >{{
                                    row.item.movement.date_brt | smallDateTime
                                }}</span
                            >
                            <span v-else class="text-left text-gray-400"
                                >--/--/----</span
                            >
                        </template>

                        <template slot-scope="row" slot="origin">
                            <div v-if="row.item.movement">
                                <div
                                    class="text-xs  text-left text-gray-400 uppercase"
                                >
                                    {{ row.item.movement.name }}
                                </div>
                                <div class="text-left text-gray-500">
                                    <em class="fas fa-address-card"></em>
                                    {{ row.item.movement.federal_document }}
                                </div>
                            </div>
                            <div v-else class="text-left text-gray-500">
                                <em class="fas fa-address-card"></em>
                                ----------
                            </div>
                        </template>

                        <template slot-scope="row" slot="description">
                            <div
                                class="text-left font-semibold text-gray-600 uppercase"
                            >
                                {{ row.item.description }}
                            </div>
                            <div class="text-left text-gray-400">
                                {{ row.item.descri_bank }}
                            </div>
                        </template>

                        <template slot-scope="row" slot="updated">
                            <span
                                v-if="
                                    row.item.updated &&
                                        row.item.status === 'paid'
                                "
                                class="text-left text-gray-700"
                                >{{ row.item.updated | smallDateTime }}</span
                            >
                            <span v-else class="text-left text-gray-400"
                                >--/--/----</span
                            >
                        </template>

                        <template slot-scope="row" slot="amount">
                            <div
                                class=" w-full text-sm text-left font-bold text-blck"
                            >
                                R${{ row.item.amount | currency }}
                            </div>
                        </template>
                    </inertia-table>
                </div>
            </div>
        </div>
    </app-layout>
</template>
<script>
import AppLayout from "./../../Layouts/AppLayout";
import Welcome from "./../../Jetstream/Welcome";
import Dropdown from "../../Jetstream/Dropdown";
import DropdownLink from "../../Jetstream/DropdownLink";
import JetAutoComplete from "../../Jetstream/AutoComplete";
import Flash from "../../Helpers/Flash";
import InertiaTable from "../../Helpers/Tables/InertiaTable";
import Input from "../../Jetstream/Input";
import Balance from "../../Helpers/Balance";
import { ToggleButton } from "vue-js-toggle-button";
import InertiaLink from "../../Jetstream/NavLink";

export default {
    components: {
        Balance,
        Input,
        Dropdown,
        AppLayout,
        Welcome,
        DropdownLink,
        Flash,
        JetAutoComplete,
        InertiaTable,
        ToggleButton,
        InertiaLink
    },
    props: ["valuesReceive", "account", "errors"],
    data: function() {
        return {
            availableMoney: this.valuesReceive.pendings.price,
            daily: !!this.account.income_config.interval,
            form: this.$inertia.form({
                _method: "POST",
                isDaily: null
            }),

            columns: [
                {
                    text: "Status",
                    className: "text-left text-gray-400",
                    key: "status",
                    sortable: true
                },
                {
                    text: "Data de realização",
                    className: "text-left text-gray-400",
                    key: "movement.date_brt",
                    sortable: false
                },
                {
                    text: "Origem",
                    className: "text-left text-gray-400",
                    key: "origin",
                    sortable: false
                },
                {
                    text: "Descrição",
                    className: "text-left text-gray-400",
                    key: "description",
                    sortable: false
                },
                {
                    text: "Data de saque",
                    className: "text-left text-gray-400",
                    key: "updated"
                },
                {
                    text: "Valor",
                    className: "text-left text-gray-400",
                    key: "amount",
                    sortable: false
                }
            ],

            filters: [
                {
                    text: "Status",
                    key: "status",
                    type: "dropdown",
                    colSpan: 2,
                    options: [
                        { id: "pending", name: "Pendente" },
                        { id: "processing", name: "Em andamento" },
                        { id: "paid", name: "Recebido" }
                    ]
                },
                {
                    text: "Data da realização",
                    key: "date_from",
                    type: "datepicker",
                    colSpan: 2
                },
                {
                    text: "Data de saque",
                    key: "date_to",
                    type: "datepicker",
                    colSpan: 2
                }
            ],

            params: {
                sort: "date_brt:desc",
                page: 1,
                ...this.$page.props.queryString
            }
        };
    },
    watch: {
        account() {
            this.daily = !!this.account.income_config.interval;
        }
    },

    methods: {
        activateCash() {
            this.form.isDaily = this.daily;
            this.form.post("/json/active-withdrawal", {
                onSuccess: () => {
                    this.$forceUpdate();
                },
                onError: () => {
                    this.$forceUpdate();
                }
            });
        },

        statusData(status) {
            switch (status) {
                case "paid":
                    return {
                        bg: "bg-green-100",
                        icon: "far fa-check-circle text-green-400",
                        name: "Recebido"
                    };
                case "rejected":
                    return {
                        bg: "bg-red-100",
                        icon: "far fa-times-circle text-red-400",
                        name: "Recusado"
                    };
                case "pending":
                    return {
                        bg: "bg-yellow-100",
                        icon: "fas fa-hourglass-end text-yellow-600",
                        name: "Pendente"
                    };
                case "processing":
                    return {
                        bg: "bg-blue-100",
                        icon: "fas fa-ellipsis-h text-blue-600",
                        name: "Em andamento"
                    };
                default:
                    return {
                        bg: "bg-gray-100",
                        icon: "fas fa-question-circle text-gray-400",
                        name: "Não definido"
                    };
            }
        }
    }
};
</script>
